module.exports = __webpack_public_path__ + "img/icon5.8a3aedb2.jpg";